export const BANNER_EVENT_FETCH = 'BANNER_EVENT_FETCH_REQUEST';
export const BANNER_EVENT_DATA = 'BANNER_EVENT_DATA';
export const BANNER_EVENT_ERROR = 'BANNER_EVENT_ERROR';
export const DEFAULT_PAGE_SIZE = 10;
